export const arrayModalidade = ['Presencial', 'Remoto', 'Híbrido']
